import * as React from 'react';
import { Member } from 'src/modules/member/models/member';
import { Box, Popover } from '@mui/material';
import { MemberDetailsSummary } from './memberDetailsSummary';

type MemberDetailPopoverProps = {
  member: Member;
  children: React.ReactNode;
};

export const MemberDetailPopover = (props: MemberDetailPopoverProps) => {
  const { member, children } = props;
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const componentId = `popover-${Date.now().toString(36) + Math.random().toString(36).substring(2)}`;

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Box sx={{ display: 'flex' }}>
      <Box aria-owns={open ? componentId : undefined} aria-haspopup='true' onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose}>
        {children}
      </Box>
      <Popover
        id={componentId}
        sx={{
          pointerEvents: 'none',
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        hideBackdrop
        disableRestoreFocus
      >
        <Box sx={{ p: 1 }}>
          <MemberDetailsSummary member={member} />
        </Box>
      </Popover>
    </Box>
  );
};
